import { computed } from '@angular/core';
import {
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
} from '@ngrx/signals';
import { RoleState } from './role.state';
import { Role, roleTemplates } from '../../models/rbac';

export function withRoleSelectors() {
  return signalStoreFeature(
    {
      state: type<RoleState>(),
    },
    withMethods(store => ({
      getRolesByIds(ids: string[]) {
        const roles: Role[] = [];
        ids.forEach(id => {
          roles.push(store.items()[id]);
        });
        return roles;
      },
    })),
    withComputed(({ items }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => Object.values(items())),
      availableTemplates: computed(() => {
        const currentRoles = Object.values(items());
        // Helper to compare accessList deeply (all keys and values)
        const sameAccessList = (a: any, b: any): boolean => {
          const keysA = Object.keys(a ?? {});
          const keysB = Object.keys(b ?? {});
          if (keysA.length !== keysB.length) return false;
          // Compare each key and value (no key property assumption)
          return keysA.every(key => a[key] === b[key]);
        };

        return roleTemplates.filter(
          template =>
            !currentRoles.some(role =>
              sameAccessList(role.accessList, template.accessList)
            )
        );
      }),
    }))
  );
}
